{
    "webshop_offer_voucher_correctCode": "Korrekten Code eingegeben",
    "webShop_howToFindId_desc": "Ihr könnt Eure persönliche ID in Eurem Spielerprofil finden und kopieren.",
    "webShop_howToFindId_link": "Wo finde ich meine persönliche ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Code stimmt nicht",
    "webshop_offer_voucher_enterYourCode": "Gebt Eure persönliche ID ein.",
    "webShop_unexpectedError_desc": "Ein unerwarteter Fehler ist aufgetreten. Bitte versucht es später erneut.",
    "webShop_accountBanned_desc": "Account gesperrt!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "AGB",
    "webshop_purchase_privacyPolicy": "Datenschutzerklärung",
    "webshop_legal_1": "Rechtliches",
    "webshop_support_1": "Support",
    "mbs_access_welcome_desc": "Willkommen, {0}",
    "btn_login": "Login",
    "mbs_access_error_sessionExpired_desc": "Eure Sitzung ist abgelaufen, bitte die Account-ID manuell eingeben."
}
